import useBreakpointHook from 'use-breakpoint';
import { useMemo } from 'react';

const useBreakpoint = (breakpoints) => {
  const breakpointResult = useBreakpointHook(breakpoints, 'lg');

  const result = useMemo(() => {
    const xs = breakpointResult.breakpoint === 'xs';
    const mobile = breakpointResult.breakpoint === 'mobile';
    const sm = breakpointResult.breakpoint === 'sm';
    const md = breakpointResult.breakpoint === 'md';
    const lg = breakpointResult.breakpoint === 'lg';
    const xl = breakpointResult.breakpoint === 'xl';

    return {
      isMediaMobile: mobile,
      isMediaXs: mobile || xs,
      isMediaSm: xs || mobile || sm,
      isMediaMd: xs || mobile || sm || md,
      isMediaLg: xs || mobile || sm || md || lg,
      isMediaXl: xs || mobile || sm || md || lg || xl,

      isMedia: ({ from, to }) => {
        return (
          (from ? breakpoints[breakpointResult.breakpoint] >= from : true) &&
          (to ? breakpoints[breakpointResult.breakpoint] < to : true)
        );
      },
    };
  }, [breakpointResult.breakpoint]);

  return result;
};

export default useBreakpoint;
